import React from "react";

export const SectionLoader = ({ height = 400, bgColor = "dark" }) => {
  return (
    <div
      className={`flex items-center justify-center py-4 my-4 rounded z-50 w-full ${bgColor === "dark" ? "bg-body/40" : "bg-[#ffffff]"}`}
      style={{ height: `calc(100dvh - ${height}px` }}
    >
      <div className="w-16 h-16 border-4 border-primary/50 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};
